// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__207sI","choiceBoxes":"toolbarselects_choiceBoxes__3ouNW","simpleField":"toolbarselects_simpleField__309jH"};